import React from 'react';
import { connect } from 'react-redux'
import ListaDeUsuarios from './ListaDeUsuarios';

////Importación de actions.
import {
    getData,
    searchUser,
    setActivosCheckbox,
    setBloqueadosCheckbox,
    setEliminadosCheckbox,
    orderColumn,
    setAllCheckbox,
    setCheckbox,
    setUserState,
    setMotivoBloqueo,
    resetStateListUser
} from '../actions/ListaDeUsuarios';

const mapStateToProps = (state) => {
    return {
        data: state.listaDeUsuarios,
        concierge: state.concierge
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getData: (executionContext, currentScope) => {
            dispatch(getData(executionContext, currentScope));
        },
        searchUser: (usuario) => {
            dispatch(searchUser(usuario));
        },
        setActivosCheckbox: (usuario) => {
            dispatch(setActivosCheckbox(usuario));
        },
        setBloqueadosCheckbox: (usuario) => {
            dispatch(setBloqueadosCheckbox(usuario));
        },
        setEliminadosCheckbox: (usuario) => {
            dispatch(setEliminadosCheckbox(usuario));
        },
        orderColumn: (usuario) => {
            dispatch(orderColumn(usuario));
        },
        setAllCheckbox: (allCheckboxFilter, currentUser) => {
            dispatch(setAllCheckbox(allCheckboxFilter, currentUser));
        },
        setCheckbox: (usuarioId) => {
            dispatch(setCheckbox(usuarioId));
        },
        setUserState: (id, activo, bloqueado) => {
            dispatch(setUserState(id, activo, bloqueado));
        },
        setMotivoBloqueo: (motivoBloqueo) => {
            dispatch(setMotivoBloqueo(motivoBloqueo));
        },
        resetStateListUser: () => {
            dispatch(resetStateListUser());
        }
    }
}

const ListaDeUsuariosContainer = connect(mapStateToProps, mapDispatchToProps)(ListaDeUsuarios);

export default ListaDeUsuariosContainer;
